import { COLOR, FONT_SIZE, mq, RatingStar as _RatingStar, Tag as _Tag } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivSupplementBox = styled.div`
  display: flex;
  align-items: center;
  color: ${COLOR.GRAY900.code};
  font-size: ${FONT_SIZE.S}px;
`;

export const RatingStar = styled(_RatingStar)`
  margin-right: 8px;
`;

export const ParText = styled.p`
  font-size: 14px;
  margin-right: 8px;
  // MEMO : アイコンと一緒に並べる時に行間が広いことで中央寄せにならないので以下のline-heightを指定する
  line-height: 1;

  ${mq.sp} {
    font-size: 12px;
  }
`;

export const Tag = styled(_Tag)`
  margin-right: 8px;
`;
